import React from 'react';
import { formatDate, dashBoardformatDate } from 'utils';
// import { fetchConfigarationData, kudzuPlusTrueFun } from '../../../helpers/utils/Utils';
import { fetchConfigarationData, kudzuPlusTrueFun } from 'helpers/utils/Utils';
import { useSelector, useDispatch } from 'react-redux';
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi';
import Delete from '../../../../../../assets/smi-kudzu-images/delete_icon.png'
import Edit from '../../../../../../assets/smi-kudzu-images/edit_icon.png'

const appConfigData = await fetchConfigarationData();

const BillersData = ({ transactionData, redirectToBillerDetails , openRemoveBiller, openModifyBiller , details}) => {
  const { BillerName, AccountNumber} = transactionData;
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const styleAll = `font-[400] my-auto font-[500] font-hanken-grotesk md:text-[18px] sm:text-[11px] text-[16px]`
  const styleStatus = `font-[400] y-auto font-hanken-grotesk md:text-[18px] md:text-[17px] sm:text-[11px] text-[16px] `
  //text-[#262B3A]
  return (
    <tr className="">
      <td onClick={ () => {redirectToBillerDetails(transactionData)}} className={`${kudzuPlusTrue ? "text-white": "text-black"} pb-5 cursor-pointer text-left font-[500] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem]
       max-w-[11rem] break-words  ${styleAll} 
        text-[var(--text-clr-transactions)]`}>
        {BillerName}
      </td>

       <td onClick={ () => {
        redirectToBillerDetails(transactionData);
        dispatch({ type: 'BILLER_TYPE', payload: { billerType: transactionData?.BillerType } });
      }} className={`${kudzuPlusTrue ? "text-white": "text-black"} pb-5 cursor-pointer text-left font-[500] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem]
       max-w-[11rem] break-words  ${styleAll} 
        text-[var(--text-clr-transactions)]`}>
        {AccountNumber}
      </td>

       <td className={`sm:table-cell flex justify-end items-center pb-5 text-right font-[500] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem] max-w-[11rem] ${styleAll} text-[var(--text-clr-transactions)]`}>
            <div className="flex items-center justify-end gap-3">
          <img src={Edit} alt="Edit" className="w-5 h-5 cursor-pointer" 
           onClick={ 
            ()=>{
              openModifyBiller();
               details(transactionData)
               dispatch({ type: 'BILLER_TYPE', payload: { billerType: transactionData?.BillerType } });
               dispatch({ type: 'MODIFY_BILLER_ID', payload: { modifyBillerID: transactionData?.BillerID } });
            }} />
          <img src={Delete} alt="Delete" onClick={ () => {
            openRemoveBiller();
            dispatch({ type: 'REMOVE_BILLER_ID', payload: { removeBillerId: transactionData?.SVABillerKey } });
            }} className="w-5 h-5 cursor-pointer" />
        </div>
      </td>
    </tr>
  );
};



export default BillersData;
